function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.43242 12.0862L3.73625 14.6852L1.19176 14.739C0.431328 13.3286 0 11.7148 0 10C0 8.34176 0.403281 6.77801 1.11812 5.40109H1.11867L3.38398 5.8164L4.37633 8.06812C4.16863 8.67363 4.05543 9.32363 4.05543 10C4.05551 10.7341 4.18848 11.4374 4.43242 12.0862Z",
  fill: "#FBBB00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.8254 8.13187C19.9402 8.7368 20.0001 9.36152 20.0001 10C20.0001 10.7159 19.9249 11.4143 19.7815 12.0879C19.2947 14.3802 18.0227 16.3819 16.2606 17.7984L16.26 17.7978L13.4068 17.6522L13.0029 15.1313C14.1722 14.4456 15.0859 13.3725 15.5672 12.0879H10.22V8.13187H15.6452H19.8254Z",
  fill: "#518EF8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2598 17.7978L16.2603 17.7984C14.5466 19.1758 12.3697 20 9.99989 20C6.19165 20 2.88067 17.8714 1.19165 14.739L4.43231 12.0863C5.27681 14.3401 7.45099 15.9445 9.99989 15.9445C11.0955 15.9445 12.1219 15.6484 13.0026 15.1313L16.2598 17.7978Z",
  fill: "#28B446"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.383 2.30219L13.1434 4.95437C12.2319 4.38461 11.1544 4.05547 10 4.05547C7.39344 4.05547 5.17859 5.73348 4.37641 8.06812L1.11871 5.40109H1.11816C2.78246 2.1923 6.1352 0 10 0C12.4264 0 14.6511 0.864297 16.383 2.30219Z",
  fill: "#F14336"
}));

var SvgGoogleIcon = function SvgGoogleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-icon.1d77d6c7.svg";
export { ForwardRef as ReactComponent };